import React from 'react'
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, ButtonGroup } from 'reactstrap';

import bootbox from 'components/Modals/Bootbox';
import { fetcher } from 'api/client';
import { clientContractAction } from 'api/actions/contracts';
import { useSign, CONTROL_MODAL, CONFIRM_UPLOAD_MODAL } from 'context/signview';

export default function ConfirmUpload() {

    //CHECK

    const [{ contractId, modal, wordonline = {}, jwt }, dispatch] = useSign();
    const { t } = useTranslation();

    const { mutate: acceptMutation } = useMutation((payload) => fetcher(clientContractAction(contractId, 'uploadwordversion', payload), jwt), {
        onSuccess: () => {
            handleClose();
            bootbox.alert({
                title: t('sign.new_version_modal.title'),
                text: t('sign.new_version_modal.body'),
            })
        }, onError: (error) => {
            bootbox.alert({
                title: t('sign.new_version_modal.title'),
                text: t(`error.${error.message}`),
            })
        }
    });

    const handleAccept = async () => {
        if (await bootbox.confirm(t('contracts.negotiation.confirm_send'))) {
            acceptMutation({
                name: wordonline.BaseFileName,
                filename: wordonline.BaseFileName,
                url: wordonline.url,
                VersionId: wordonline.VersionId,
                fileSize: wordonline.fileSize
            })
        }
    };

    const handleClose = () => {
        dispatch({ type: CONTROL_MODAL, close: CONFIRM_UPLOAD_MODAL });
    }

    return (
        <Modal isOpen={modal.includes(CONFIRM_UPLOAD_MODAL)} centered>
            <ModalHeader toggle={handleClose}>
                {t('contracts.negotiation.send_version')}
            </ModalHeader>
            <ModalBody>
                <section className="negotiate-section">
                    <p className="text-body">
                        {t('contracts.negotiation.selected_send')}
                        {' '}<b>{wordonline.BaseFileName}</b>{' '}
                        {t('contracts.negotiation.selected_confirm')}
                    </p>
                </section>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button color="secondary" onClick={handleClose}>
                        {t('contracts.negotiation.cancel')}
                    </Button>
                    {/* <button className="btn btn-blue" onClick={handleChange}>
                        {t('contracts.negotiation.change')}
                    </button> */}
                    <Button color="primary" onClick={handleAccept}>
                        {t('contracts.negotiation.sendBtn')}
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    )
}
